import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className="relative flex h-9 w-16 items-center rounded-full border border-border bg-secondary px-1 transition-colors"
    >
      <motion.span
        layout
        transition={{ type: "spring", stiffness: 500, damping: 32 }}
        className={`flex h-7 w-7 items-center justify-center rounded-full text-background ${
          isDark ? "ml-auto bg-neon-cyan" : "mr-auto bg-neon-magenta"
        }`}
      >
        {isDark ? <Moon size={15} /> : <Sun size={15} />}
      </motion.span>
      <Sun
        size={14}
        className={`absolute left-2.5 text-muted-foreground ${isDark ? "opacity-100" : "opacity-0"}`}
      />
      <Moon
        size={14}
        className={`absolute right-2.5 text-muted-foreground ${isDark ? "opacity-0" : "opacity-100"}`}
      />
    </button>
  );
}
